// https://cdn.shopify.com/s/files/1/1336/0641/files/Genealogist_list.xlsx?v=1772076953

document.addEventListener('DOMContentLoaded', () => {
    /* ===== genealogist ==== */
     async function processExcelFile() {
        const res = await fetch("https://cdn.shopify.com/s/files/1/1336/0641/files/Genealogist_list.xlsx?v=1772666200");
        const data = await res.arrayBuffer();
        const wb = XLSX.read(data, { type: "array" });

        const sheet = wb.Sheets["genealogists"];
        const rows = XLSX.utils.sheet_to_json(sheet);

        const genealogist_List = {};
        var genealogist_tag_array = [];

        rows.forEach(row => {

            // console.log("row.nameg", row.name);

            // console.log("row.genealogist_tag", row.genealogist_tag);
            //var tagSplit = row.genealogist_tag;



            genealogist_List[row.name] = {
                url: row.url,
                genealogist: row.genealogist_tag.split(",").map(item => item.trim()),
                tooltip: row.tooltip
            };
        });

        return genealogist_List;
    }

    if (typeof XLSX !== "undefined") {
        processExcelFile().then(genealogist_List => {
           // console.log("Final Object:", genealogist_List);

            var time_Period = localStorage.Immigration;
            findTimePeriodGenealogist(genealogist_List, time_Period);
        });

    } else {
        console.error("XLSX library not loaded yet.");
    }
});
function findTimePeriodGenealogist(genealogists, period){
  var genealogist_Dom = document.getElementById("genealogist_list");

  for (const outerKey in genealogists) {
      if (genealogists.hasOwnProperty(outerKey)) { // Ensure it's not from the prototype chain
          const innerObject = genealogists[outerKey];
          for (const innerKey in innerObject) {
            if (innerObject.hasOwnProperty(innerKey)) {
              var inner_key = `${innerKey}`;
              if( inner_key == "genealogist"  && `${innerObject[innerKey]}`.indexOf(period) != -1 ){
              //  console.log(`  Inner key: ${innerKey}, Value: ${innerObject[innerKey]}`);
               // console.log( "1820_European_Immigrations");
                printGenealogist(outerKey, innerObject, genealogist_Dom);
              }
            }
          }
        }
  }

  printSearchLink(genealogist_Dom);
}
function printGenealogist(genealogistObj,  genealogistVal, domEl ){

      var listEl = document.createElement('li');
      var linkEl = document.createElement('a');
      var tooltipEl = document.createElement('span');

      // Set the link's attributes
      listEl.className = "tooltip text-room-links";
      linkEl.href = `${genealogistVal["url"]}`;
      linkEl.textContent = `${genealogistObj}`;
      linkEl.target="_blank";
      listEl.appendChild(linkEl);
      tooltipEl.className = "tooltiptext";
      tooltipEl.textContent = `${genealogistVal["tooltip"]}`;
      listEl.appendChild(tooltipEl);
      domEl.append(listEl);


    

}




function printSearchLink(domEl){
    var listEl = document.createElement('li');
      var linkEl = document.createElement('a');

      if(localStorage.BuyButton == "MayflowerSociety"){
         linkEl.href = "https://themayflowersociety.org/genealogy/genealogy-tips-tools/";
      } else {
        linkEl.href = "https://members.apgen.org/members/directory/search_APG.php?org_id=APG";
      }

      // Set the link's attributes
      
      linkEl.textContent = "Search";
      linkEl.target="_blank";
      listEl.appendChild(linkEl);
      domEl.append(listEl);
}